import { PropertyCategories, PropertyOnlyTokens, PropertyOnlyTokenToCategory, HUBSPOT_OWNER_PROPERTY_NAME, USER_PROPERTY_TYPE, CONTACT_FQN, COMPANY_FQN, DEAL_FQN, TICKET_FQN, LINE_ITEM_FQN, QUOTE_FQN, SUBSCRIPTION_FQN, FEEDBACK_SUBMISSION_FQN, PAYMENT_FQN, GOAL_TARGET_FQN, COMMERCE_PAYMENT_FQN, LEAD_FQN } from '../constants/properties';
const categoriesWithGlobalDefaultValues = [PropertyCategories.CONTACT, PropertyCategories.COMPANY];
const categoriesWithoutDefaultValues = [PropertyCategories.SITE_SETTINGS, PropertyCategories.SUBSCRIPTION_TYPE];
/**
 * Keep `LegacyTypesFQNs` and `isLegacyObjectType` for workflows since they pull
 * FQNs from an API and have been relying on these utils to adjust FQN casing.
 */
const LegacyTypeFQNs = [CONTACT_FQN, COMPANY_FQN, DEAL_FQN, TICKET_FQN, LINE_ITEM_FQN, QUOTE_FQN, SUBSCRIPTION_FQN, FEEDBACK_SUBMISSION_FQN, PAYMENT_FQN, COMMERCE_PAYMENT_FQN, GOAL_TARGET_FQN, LEAD_FQN].map(fqn => fqn.toUpperCase());
export function isLegacyObjectType(type) {
  return type ? LegacyTypeFQNs.includes(type) : false;
}
export const i18nKey = key => `RichTextLib.personalize.${key}`;
export const isCustomObjectCategory = category => !Object.values(PropertyCategories).includes(category);
export const isUserProperty = property => {
  if (!property) {
    return false;
  }
  return property.name === HUBSPOT_OWNER_PROPERTY_NAME || property.referencedObjectType === USER_PROPERTY_TYPE;
};
const PropertyOnlyCategories = ['subscription_type', 'property-only'];
export const getIsPropertyOnlyToken = (category, property) => {
  return (!category || PropertyOnlyCategories.includes(category)) && PropertyOnlyTokens.includes(property);
};
export const getCategoryTextForOption = (currentOption, categoryOptions) => {
  const currentProperty = currentOption.property;
  let currentCategory = currentOption.category;
  if (getIsPropertyOnlyToken(currentCategory, currentProperty)) {
    // some snowflake tokens don't get persisted with a category
    // value, even though they have one in the UI
    currentCategory = PropertyOnlyTokenToCategory[currentProperty];
  }
  const currentCategoryOption = categoryOptions.find(option => option.value === currentCategory);
  return currentCategoryOption && currentCategoryOption.text;
};
export const getSettingsKey = (propertyCategory, isEmail = false) => {
  switch (propertyCategory) {
    case PropertyCategories.CONTACT:
      return isEmail ? 'mergeTagDefaults' : 'pageMergeTagDefaults';
    case PropertyCategories.COMPANY:
      return isEmail ? 'accountMergeTagDefaults' : 'pageAccountMergeTagDefaults';
    default:
      return '';
  }
};
export const getCategoryCanHaveGlobalDefaultValue = category => categoriesWithGlobalDefaultValues.includes(category);
export const getCategoryCannotHaveDefaultValue = category => categoriesWithoutDefaultValues.includes(category);
export const propertyCanHaveGlobalDefaultValue = ({
  name,
  category
}) => {
  return name && getCategoryCanHaveGlobalDefaultValue(category);
};
export const propertyCanHaveDefaultValue = (currentOption, selectedUserProperty) => {
  const selectedProperty = currentOption.name;
  const selectedCategory = currentOption.category;
  const isUserPropertyWithGlobalDefault = isUserProperty(currentOption) && getCategoryCanHaveGlobalDefaultValue(selectedCategory);
  const isUserPropertyWithoutSelectedUserProperty = isUserProperty(currentOption) && !selectedUserProperty;
  return selectedProperty && !isUserPropertyWithGlobalDefault && !isUserPropertyWithoutSelectedUserProperty && !getCategoryCannotHaveDefaultValue(selectedCategory);
};
export const getUseLocalDefaultValue = ({
  defaultValue,
  currentOption
}) => {
  if (!currentOption.category) {
    return false;
  }
  return getCategoryCanHaveGlobalDefaultValue(currentOption.category) ? defaultValue === null && !isUserProperty(currentOption) : !getCategoryCannotHaveDefaultValue(currentOption.category);
};
export const getDefaultValue = (propertyName, category, siteSettings, isEmail) => {
  const settingsKey = getSettingsKey(category, isEmail);
  if (propertyName && settingsKey) {
    const settings = siteSettings[settingsKey];
    if (settings) {
      const defaultValue = settings[propertyName];
      if (defaultValue) {
        return defaultValue;
      }
    }
  }
  return null;
};
export const createTokenString = ({
  prefix = '',
  category,
  property,
  subProperty,
  defaultValue,
  filter
}) => {
  const hasPrefix = prefix && prefix.length !== 0;
  if (getIsPropertyOnlyToken(category, property)) {
    return `{{ ${hasPrefix ? prefix : property} }}`;
  }
  const tokenBase = `${hasPrefix ? prefix : category}.${property}${subProperty ? `.${subProperty}` : ''}`;
  if (defaultValue === null) {
    return `{{ ${tokenBase}${filter ? `|${filter}` : ''} }}`;
  }
  return `{{ personalization_token('${tokenBase}', '${defaultValue}')${filter ? `|${filter}` : ''} }}`;
};
export const getTagUseFromCategory = (category = '') => {
  switch (category.toLowerCase()) {
    case PropertyCategories.CONTACT:
      return 'sorbet';
    case PropertyCategories.COMPANY:
      return 'calypso';
    case PropertyCategories.SITE_SETTINGS:
      return 'default';
    case PropertyCategories.DEAL:
    case PropertyCategories.QUOTE:
      return 'success';
    case PropertyCategories.LINE_ITEM:
      return 'warning';
    default:
      return 'thunderdome';
  }
};